/*
 * @Author: Merlin
 * @Date: 2024-02-21 10:41:34
 * @LastEditors: Merlin
 * @LastEditTime: 2024-12-23 09:46:15
 * @Description: 
 */


const introduction = {
    previewTitle: {
        en: 'Experience the classic Roulette',
        cn: '体验经典 Roulette',
    },
    previewSubtitle: {
        en: 'Play the new Original game',
        cn: '玩全新原创游戏',
    },
    previewDesc: {
        en: 'Discover the iconic European Roulette on BetCorgi. Place your bets, feel the thrill, and watch as the ball lands on one of the 37 numbers. Let the wheel determine your fate!',
        cn: '探索标志性的欧式 Roulette 于 BetCorgi。下注，感受快感并看着球落在 37 个数字之一。让轮盘决定你的命运！',
    },
    featureTitle: {
        en: 'Enjoy endless winning possibilities',
        cn: '享受不停获胜的可能性',
    },
    featureDesc: {
        en: 'Immerse yourself in the gameplay with the different features and explore a variety of inside, outside, and section bets.',
        cn: '让自己沉浸在的游戏当中并探索多样的内圈、外圈与区域押注。',
    },
    dragAndDrop: {
        en: 'Drag’n’drop feature',
        cn: '拖放功能',
    },
    sectionBets: {
        en: 'Section bets',
        cn: '区域押注',
    },
};

const specialButtons = {
    Voisins: {
        en: 'Voisins',
        cn: '邻近号码',
    },
    Orphelins: {
        en: 'Orphelins',
        cn: '孤儿号码',
    },
    Tiers: {
        en: 'Tiers',
        cn: '分段号码',
    },
    Zero: {
        en: 'Zero',
        cn: '零游戏',
    },
    Red: {
        en: 'Red',
        cn: '红',
    },
    Black: {
        en: 'Black',
        cn: '黑',
    },
    even: {
        en: 'even',
        cn: '双',
    },
    odd: {
        en: 'odd',
        cn: '单',
    },
};


const oPayList = {
    bet_Straight:{
        en: 'Straight',
        cn: '单注',
    },
    bet_Split:{
        en: 'Split',
        cn: '分注',
    },
    bet_Street:{
        en: 'Street',
        cn: '行注',
    },
    bet_Corner:{
        en: 'Corner',
        cn: '角注',
    },
    bet_SixLine:{
        en: 'Six line',
        cn: '线注',
    },
    bet_ColumnBet:{
        en: 'Column bet', // 某一行 
        cn: '列注',
    },
    bet_firstDozen:{
        en: 'First dozen',
        cn: '第一打',
    },
    bet_secondDozen:{
        en: 'Second dozen',
        cn: '第二打',
    },
    bet_thirdDozen:{
        en: 'Third dozen',
        cn: '第三打',
    },
    bet_RedBlackNumbers: {
        en: 'Red/Black Numbers',
        cn: '红黑注',
    },
    bet_OddEvenNumbers: {
        en: 'Odd/Even Numbers',
        cn: '单双注',
    },
    bet_LowHigh:{
        en: 'Low/High',
        cn: '大小注',
    },
}


const oPayListDesc = {
    desc_Straight:{
        en: '1 number',
        cn: '押一个数字',
    },
    desc_Split:{
        en: '2 numbers',
        cn: '押两个数字',
    },
    desc_Street:{
        en: '3 numbers',
        cn: '押三个数字',
    },
    desc_Corner:{
        en: '4 numbers',
        cn: '押四个数字',
    },
    desc_SixLine:{
        en: '6 numbers',
        cn: '押六个数字',
    },
    desc_ColumnBet:{
        en: '', // 某一行 
        cn: '押一列数字',
    },
    desc_firstDozen:{
        en: '1 to 12',
        cn: '1 到 12',
    },
    desc_secondDozen:{
        en: '13 to 24',
        cn: '13 到 24',
    },
    desc_thirdDozen:{
        en: '25 to 36',
        cn: '25 到 36',
    },
    desc_RedBlackNumbers: {
        en: '',
        cn: '',
    },
    desc_OddEvenNumbers: {
        en: '',
        cn: '',
    },
    desc_LowHigh:{
        en: '1 to 18/19 to 36',
        cn: '1 到 18/19 到 36',
    },
}


const oHistroyDialogTitle = {
    'title_2-1-1': {
        en: '1st column 2 to 1', 
        cn: '第一列', 
    },
    'title_2-1-2': {
        en: '2nd column 2 to 1', 
        cn: '第二列', 
    },
    'title_2-1-3': {
        en: '3rd column 2 to 1', 
        cn: '第三列', 
    },
    // ==========================
    'title_1-12': {
        en: 'Dozen 1st-12', 
        cn: '第一打', 
    },
    'title_13-24': {
        en: 'Dozen 2nd-12', 
        cn: '第二打', 
    },
    'title_25-36': {
        en: 'Dozen 3rd-12', 
        cn: '第三打', 
    },
    'title_1to18': {
        en: '1-18', 
        cn: '1-18', 
    },
    'title_19to36': {
        en: '19-36', 
        cn: '19-36', 
    },
    'title_even': {
        en: 'EVEN', 
        cn: '偶数', 
    },
    'title_odd': {
        en: 'ODD', 
        cn: '奇数', 
    },
    'title_red': {
        en: 'Red', 
        cn: '红', 
    },
    'title_black': {
        en: 'Black', 
        cn: '黑', 
    },
}



export const oRouletteGame = {
    ...specialButtons,
    ...introduction,
    ...oPayList,
    ...oPayListDesc,
    ...oHistroyDialogTitle,
    ChipValue: {
        en: 'Chip value',
        cn: '价值',
    },
    SectionBets: {
        en: 'Section Bets',
        cn: '区域押注',
    },
    InsufficientBalance: {
        en: 'Insufficient balance',
        cn: '余额不足',
    },
    MaxBetReached: {
        en: 'Max bet reached',
        cn: '已到达下注上限值',
    },
    Undo: {
        en: 'Undo',
        cn: '上一步',
    },
    Clear: {
        en: 'Clear',
        cn: '清除',
    },
    ruleDesc01: {
        en: 'Choose your chips and bet on the number or area, if the ball stops on the number you bet on you win.',
        cn: '选择筹码并下注号码或区域，如果球停在你下注的号码上即为赢。',
    },
    ruleDesc02: { en: '', cn: '', }, // Mini 版中被废弃
    ruleDesc03: { en: '', cn: '', }, // Mini 版中被废弃
    History: {
        en: 'History',
        cn: '历史',
    },
    RouletteHistory: {
        en: 'Roulette History',
        cn: 'Roulette 历史',
    },
    betsList: {
        en: 'Bets list',
        cn: '下注详情',
    },
    payout: {
        en: 'Payout',
        cn: '返现',
    },
};





